import { Box, Paper, TextField, Typography } from "@mui/material";
import { useEffect, useState, useContext } from "react";
import TimelineGraph from "../ui/TimeLineGraph";
import { Context } from "../../App";

export default function EventSellGraph({ events }) {
    const { setIsConnected } = useContext(Context);
    const [event, setEvent] = useState(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (events && events.length > 0) {
            const now = new Date();
            // Find event with dateDebut closest to now (future or past)
            const closest = events.reduce((prev, curr) => {
                const prevDiff = Math.abs(new Date(prev.dateDebut) - now);
                const currDiff = Math.abs(new Date(curr.dateDebut) - now);
                return currDiff < prevDiff ? curr : prev;
            });
            setEvent(closest);
        }
    }, [events]);

    useEffect(() => {
        if (!event) return; // If no event is selected, do not fetch data

        setLoading(true);
        
        fetch(process.env.REACT_APP_API_URL.concat(`/adm/events/${event._id}/timeline_sell`), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
        }
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    setData(json);
                }
            }
        }).catch(error => {
            console.error("Error fetching events:", error);
        }).finally(() => {
            setLoading(false);
        });
    }, [event]);

    return (
        <Paper elevation={3} sx={{ p: 2, mb: 2, minHeight: 400, display: 'flex', flexDirection: 'column'}}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent:'space-between', mb: 2, flexWrap:'wrap', rowGap:1 }}>
                <Typography variant="h5">Évolution des ventes</Typography>
                <TextField select label="Événement" value={event ? event._id : ''} slotProps={{ select: {native: true}, inputLabel:{ shrink: true} }} size="small"
                onChange={(e) => setEvent(events.find(ev => ev._id === e.target.value))} sx={{ minWidth: 200, width: '30%' }}>
                    <option value="" disabled>Sélectionner un événement</option>
                    {events.map((ev) => (<option key={ev._id} value={ev._id}>{ev.titre}</option>))}
                </TextField>
            </Box>

            {loading ?  <Box sx={{ display: 'flex', flex:1, alignItems: 'center', justifyContent: 'center', backgroundColor:'rgba(0, 0, 0, 0.1)' }}>
                <Typography>Chargement...</Typography>
            </Box> 
            : <TimelineGraph {...{ data, loading }} />}

        </Paper>
    );
}